module.exports = __webpack_public_path__ + "media/assets/gray-cross-891b02ed6a2dbd3f37ba9903ab0bad9aa48967fa7cf644d2a4a728eef4aa0d45.svg";